(function () {

    "use strict";

    angular.module("app").factory("downloadService", DownloadServiceFactory);


    DownloadServiceFactory.$inject = ["commonFunctions", "webApiServices", "notificationService", "habilBootbox", "$filter", "saveAs"];
    function DownloadServiceFactory(commonFunctions, webApiServices, notificationService, habilBootbox, $filter, saveAs) {

        const translator = $filter("habilTranslation");

        return {
            DownloadWordTemplate: downloadWordTemplate,
            DownloadCertificate: downloadCertificate,
            DownloadBVL: downloadBVL,
            SaveResult: saveResultWithName,
            saveExport,
            DownloadAttachmentByPublicId: downloadAttachmentByPublicId,
            DownloadAttachment: downloadAttachment,
        };

        function downloadAttachmentByPublicId(attachmentPublicId, finallyCallback) {
            if (!attachmentPublicId) {
                commonFunctions.invoke(finallyCallback);
                return;
            }

            const urlParam = `publicId=${attachmentPublicId}`;
            webApiServices.GetAttachmentByPublicId(urlParam)
                .then(r => saveResultWithName(r, null))
                .catch((errorResponse) => {
                    try {
                        const decoder = new TextDecoder();
                        const errorDetail = JSON.parse(decoder.decode(errorResponse.data));

                        if (errorDetail.Error) {
                            notificationService.error(translator(errorDetail.Error));
                        }
                        else {
                            notificationService.error(translator("ServerError"));
                        }
                    } catch {
                        notificationService.error(translator("ServerError"));
                    }
                })
                .finally(() => commonFunctions.invoke(finallyCallback));
        }

        function downloadAttachment(attachment, finallyCallback) {
            if (!attachment || !attachment.PublicId) {
                commonFunctions.invoke(finallyCallback);
                return;
            }

            // Different endpoints serialize enums differently
            const threatDetectedStatuses = ["ThreatDetected", "4", 4];
            if (threatDetectedStatuses.includes(attachment.ScanningStatus)) {
                commonFunctions.invoke(finallyCallback);
                habilBootbox.alert("Download not allowed, this file was flagged by a virus scanner as unsafe");
                return;
            }

            downloadAttachmentByPublicId(attachment.PublicId, finallyCallback);
        }

        function downloadWordTemplate(template, finallyCallback) {
            webApiServices.DownloadWordTemplate(
                { Template: template },
                r => saveResultWithName(r, template.Attachment.Name),
                (err) => DoShowError(notificationService, err),
                () => commonFunctions.invoke(finallyCallback)
            );
        }

        function downloadCertificate(bvl, finallyCallback) {
            webApiServices.GetCertificate(
                { Dto: bvl },
                r => saveResultWithName(r, null),
                (err) => DoShowError(notificationService, err),
                () => commonFunctions.invoke(finallyCallback)
            );
        }

        function downloadBVL(bvl, finallyCallback) {
            webApiServices.GetBVL(
                { Dto: bvl },
                r => saveResultWithName(r, null),
                (err) => DoShowError(notificationService, err),
                () => commonFunctions.invoke(finallyCallback)
            );
        }

        function saveResultWithName(result, name) {
            if (!CheckResultReceived(result)) {
                DoShowError(notificationService, result);
                return;
            }

            const actualName = name || decodeURIComponent(result.headers("HabilFileName"));
            const file = new Blob(prepareBlobParts(result));
            saveAs(file, actualName);
        }

        function saveExport(result) {
            const decodedData = atob(result.data.FileData);
            // Convert the decoded data to a Uint8Array
            const byteArray = new Uint8Array(decodedData.length);
            for (let i = 0; i < decodedData.length; i++) {
                byteArray[i] = decodedData.charCodeAt(i);
            }

            const bl = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            saveAs(bl, result.data.FileName);
        }

        function prepareBlobParts(result) {
            if (result instanceof ArrayBuffer) {
                return [result];
            }
            else if (result instanceof Array) {
                const byteArray = new Uint8Array(result.length);
                for (let i = 0; i < result.length; i++) {
                    byteArray[i] = result[i];
                }
                return [byteArray];
            }
            else {
                return [result.data];
            }
        }
    }
})();
